import cx from 'classix';

const DirectoryContainer = ({
  color,
  negativeTopMargin,
  children,
}: {
  color: 'white' | 'gray';
  negativeTopMargin?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={cx(
        'max-w-full w-full px-10',
        negativeTopMargin ? 'sm:-mt-12 sm:pt-12' : '',
        color === 'white' ? 'bg-white' : 'bg-gray-100',
      )}
    >
      <div className='max-w-[1280px] w-full mx-auto'>{children}</div>
    </div>
  );
};

export default DirectoryContainer;
